
























































































import { readChat, watchChat } from '@/services/chatData'

import { Component, Vue } from 'vue-property-decorator'
import firebase from '@/services/memberData'
import 'firebase/firestore'
import 'firebase/storage'
import 'firebase/auth'
import moment from 'moment-timezone'

interface ChatMessage {
  id?: string
  textContent?: string
  image?: string
  type: 'text' | 'image'
  time: string
  isSent: boolean
  isSeen: boolean
  createdAt?: any
  admin?: {
    email: string
    name: string
  }
}

interface AdminInfo {
  displayName: string
  avatar: string
  email: string
  firstname: string
  lastname: string
}

@Component
export default class ChatWidget extends Vue {
  isChatOpen = false
  messages: ChatMessage[] = []
  newMessage = ''
  loading = true
  uploadingImage = false
  viewingImage = ''
  unreadCount = 0
  unsubscribe: any = null
  unsubscribeUnread: any = null
  
  adminInfo: AdminInfo = {
    displayName: 'Admin Support',
    avatar: 'https://image.freepik.com/free-vector/businessman-profile-cartoon_18591-58479.jpg',
    email: 'admin@shiba888.bet',
    firstname: 'Admin',
    lastname: 'Support'
  }

  get currentUser() {
    return this.$store.state.user.user
  }

  get userKey() {
    // Try to get from store first (this is the primary source)
    if (this.$store.state.user && this.$store.state.user.user && this.$store.state.user.user.key) {
      return this.$store.state.user.user.key
    }
    
    // Try localStorage
    const userData = localStorage.getItem('userData')
    if (userData) {
      try {
        const user = JSON.parse(userData)
        if (user.key) {
          return user.key
        }
      } catch (e) {
        console.error('Error parsing userData from localStorage:', e)
      }
    }
    
    // Fallback to Firebase Auth
    const currentUser = firebase.auth().currentUser
    if (currentUser) {
      return currentUser.uid
    }
    
    return null
  }

  mounted() {
    // Listen for unread messages
    this.listenForUnreadMessages()
  }

  beforeDestroy() {
    if (this.unsubscribeUnread) this.unsubscribeUnread()
    if (this.unsubscribe) {
      this.unsubscribe()
    }
  }

  async toggleChat() {
    console.log('Toggle chat clicked')
    console.log('User key:', this.userKey)
    console.log('Current user:', this.currentUser)
    console.log('Firebase auth user:', firebase.auth().currentUser)
    
    if (!this.userKey) {
      this.$swal('Error', 'Please login to use chat', 'error')
      this.$router.push('/login')
      return
    }

    if (!this.isChatOpen) {
      this.isChatOpen = true
      await this.initializeChat()
      // ให้เวลาข้อความโหลดก่อน แล้วค่อยอัพเดทสถานะอ่านแล้ว
      setTimeout(() => {
        this.markMessagesAsRead()
      }, 500)
    }
  }

  closeChat() {
    this.isChatOpen = false
  }

  async initializeChat() {
    console.log('Initializing chat for user:', this.userKey)
    const db = firebase.firestore()
    
    try {
      // Create or update chat document
      const chatRef = db.collection('chat').doc(this.userKey)
      const chatDoc = await readChat(this.userKey)
      
      console.log('Chat doc exists:', chatDoc.exists)
      
      if (!chatDoc.exists) {
        // Create initial chat document with exact structure from image
        const chatData = {
          // ข้อมูลพื้นฐาน
          displayName: this.currentUser?.code || (this.currentUser?.firstname + ' ' + this.currentUser?.lastname) || this.currentUser?.name || `User ${this.userKey}`,
          code: this.currentUser?.code || this.userKey,
          photoURL: this.currentUser?.pictureUrl || this.currentUser?.profile || this.currentUser?.avatar || 'https://image.freepik.com/free-vector/businessman-profile-cartoon_18591-58479.jpg',
          
          // ข้อความล่าสุด
          last_message: '',
          updatetime: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
          lastuser: '',
          
          // การนับข้อความ
          unseenMsg: 0,        // จำนวนข้อความจาก user ที่ admin ยังไม่อ่าน
          adminUnseenMsg: 0,   // จำนวนข้อความจาก admin ที่ user ยังไม่อ่าน
          
          // สถานะ
          status: true,        // true = online, false = offline
          
          // ข้อมูลเพิ่มเติม
          priority: 'medium',
          tags: ['new-customer'],
          isTyping: false,
          
          // Timestamps
          createdate: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
          lastSeenAt: firebase.firestore.FieldValue.serverTimestamp()
        }
        
        console.log('Creating chat document with data:', chatData)
        await chatRef.set(chatData)
        console.log('Chat document created successfully')
      }
    } catch (error) {
      console.error('Error initializing chat:', error)
      this.$swal('Error', 'Failed to initialize chat', 'error')
      return
    }

    // Listen to messages
    if (this.unsubscribe) this.unsubscribe()
    this.unsubscribe = watchChat(this.userKey, true, (snapshot) => {
        this.messages = snapshot.docs.map(doc => {
          const data = doc.data()
          return {
            id: doc.id,
            textContent: data.textContent,
            image: data.image,
            type: data.type,
            time: data.time,
            isSent: data.isSent,
            isSeen: data.isSeen || false,
            createdAt: data.createdAt,
            admin: data.admin
          }
        })
        this.loading = false
        this.$nextTick(() => {
          this.scrollToBottom()
        })
      })
  }

  async listenForUnreadMessages() {
    if (!this.userKey) return

    if (this.unsubscribeUnread) this.unsubscribeUnread()
    this.unsubscribeUnread = watchChat(this.userKey, false, (doc) => {
        if (doc.exists) {
          const data = doc.data()
          // User ดูข้อความจาก admin ที่ยังไม่ได้อ่าน
          this.unreadCount = data?.adminUnseenMsg || 0
        }
      })
  }

  async markMessagesAsRead() {
    if (!this.userKey) return

    const db = firebase.firestore()
    await db.collection('chat').doc(this.userKey).set({
      adminUnseenMsg: 0,  // รีเซ็ตข้อความจาก admin ที่ user อ่านแล้ว
      lastSeenAt: firebase.firestore.FieldValue.serverTimestamp()
    }, { merge: true })
  }

  async sendMessage() {
    if (!this.newMessage.trim() || !this.userKey) return

    const db = firebase.firestore()
    const messageData = {
      textContent: this.newMessage,
      type: 'text',
      time: new Date().toISOString(),
      isSent: true,
      edited: false,
      isSeen: false,
      lastuser: this.currentUser?.displayName || 'User'
    }

    try {
      // สร้างข้อความใน sub-collection ตามโครงสร้างที่กำหนด
      const messageRef = await db.collection('chat')
        .doc(this.userKey)
        .collection('chats')
        .add({
          textContent: this.newMessage,
          time: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
          isSent: false,  // false = ข้อความจากลูกค้า
          isSeen: false,  // admin อ่านแล้วหรือยัง
          type: 'text',
          createdAt: firebase.firestore.FieldValue.serverTimestamp()
        })
      
      // อัพเดท document หลักตามโครงสร้างที่กำหนด
      await db.collection('chat').doc(this.userKey).set({
        last_message: this.newMessage,
        updatetime: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
        lastuser: 'customer',
        unseenMsg: firebase.firestore.FieldValue.increment(1),  // เพิ่มข้อความที่ admin ยังไม่ได้อ่าน
        status: true
      }, { merge: true })

      this.newMessage = ''
    } catch (error) {
      console.error('Error sending message:', error)
      this.$swal('Error', 'Failed to send message', 'error')
    }
  }

  async handleImageUpload(event: any) {
    const file = event.target.files[0]
    if (!file || !this.userKey) return

    this.uploadingImage = true
    
    try {
      // Upload to Firebase Storage
      const storage = firebase.storage()
      const timestamp = Date.now()
      const fileName = `chats/${this.userKey}/${timestamp}_${file.name}`
      const uploadTask = await storage.ref(fileName).put(file)
      const imageUrl = await uploadTask.ref.getDownloadURL()

      // บันทึกข้อความรูปภาพใน sub-collection
      const db = firebase.firestore()
      await db.collection('chat')
        .doc(this.userKey)
        .collection('chats')
        .add({
          image: imageUrl, // เพิ่ม field image สำหรับรูปภาพ
          time: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
          isSent: false,  // false = ข้อความจากลูกค้า
          isSeen: false,  // admin อ่านแล้วหรือยัง
          type: 'image',
          createdAt: firebase.firestore.FieldValue.serverTimestamp()
        })
      
      // อัพเดท document หลักสำหรับรูปภาพ
      await db.collection('chat').doc(this.userKey).set({
        last_message: '[Image]',
        updatetime: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
        lastuser: 'customer',
        unseenMsg: firebase.firestore.FieldValue.increment(1),  // เพิ่มข้อความที่ admin ยังไม่ได้อ่าน
        status: true
      }, { merge: true })

    } catch (error) {
      console.error('Error uploading image:', error)
      this.$swal('Error', 'Failed to upload image', 'error')
    } finally {
      this.uploadingImage = false
      event.target.value = ''
    }
  }

  viewImage(imageUrl: string) {
    this.viewingImage = imageUrl
  }

  closeImageViewer() {
    this.viewingImage = ''
  }

  formatTime(time: string) {
    return moment(time).format('HH:mm')
  }

  scrollToBottom() {
    const container = this.$refs.messagesContainer as HTMLElement
    if (container) {
      container.scrollTop = container.scrollHeight
    }
  }

  onScroll() {
    // ทำการอัพเดทข้อความที่อ่านแล้วเมื่อ user เลื่อนดูข้อความ
    if (this.isChatOpen) {
      this.markVisibleMessagesAsRead()
    }
  }

  async markVisibleMessagesAsRead() {
    if (!this.userKey) return

    const db = firebase.firestore()
    const batch = db.batch()
    let hasUpdates = false

    // หาข้อความจาก admin ที่ยังไม่ได้อ่าน
    const unreadAdminMessages = this.messages.filter(msg => 
      msg.isSent === true && msg.isSeen === false && msg.id
    )

    if (unreadAdminMessages.length > 0) {
      unreadAdminMessages.forEach(message => {
        if (message.id) {
          const messageRef = db.collection('chat')
            .doc(this.userKey)
            .collection('chats')
            .doc(message.id)
          batch.update(messageRef, { isSeen: true })
          hasUpdates = true
        }
      })

      if (hasUpdates) {
        await batch.commit()
      }
    }
  }
}
